export default __webpack_public_path__ + "be142e6c3747b7b87e60c823f7a386cb.woff";